import VueSelectionController from '@aspectus/vue-selection-controller'

const OrderView = () => import('./View')
const StateInfo = () => import('./StateInfo')

export function install(Vue) {
  Vue.component('OrderView', OrderView)
  Vue.component('OrderStateInfo', StateInfo)
  Vue.use(VueSelectionController, {
    name: 'v-selection-controller',
  })
}

export default { install }
